<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-6 form-group">
                <label for="bsl-job">Job</label>
                <wj-combo-box
                    [(ngModel)]="target.job"
                    (ngModelChange)="onJobChange()"
                    name="bsl-job"
                    id="bsl-job"
                    [itemsSource]="jobOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
            <div class="col-md-6 form-group">
                <label for="bsl-ticket">Ticket #</label>
                <input type="text" class="form-control" [(ngModel)]="target.ticketNumber" name="bsl-ticket" id="bsl-ticket" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 form-group">
                <label for="bsl-address">Address</label>
                <input type="text" class="form-control" [(ngModel)]="target.address" name="bsl-address" id="bsl-address" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 form-group">
                <label for="bsl-ordered">Order date</label>
                <wj-input-date [(ngModel)]="target.orderedDate" name="bsl-ordered" id="bsl-ordered" [isRequired]="false"></wj-input-date>
            </div>
            <div class="col-md-4 form-group">
                <label for="bsl-legal">Legal date</label>
                <wj-input-date [(ngModel)]="target.legalDate" name="bsl-legal" id="bsl-legal" [isRequired]="false"></wj-input-date>
            </div>
            <div class="col-md-4 form-group">
                <label for="bsl-update">Update date</label>
                <wj-input-date [(ngModel)]="target.ticketUpdateDate" name="bsl-update" id="bsl-update" [isRequired]="false"></wj-input-date>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 form-group">
                <label for="bsl-time">Time</label>
                <wj-input-time
                    [(ngModel)]="requestTimeValue"
                    name="bsl-time"
                    id="bsl-time"
                    [step]="15"
                    [min]="requestTimeMin"
                    [max]="requestTimeMax"
                    [isRequired]="false"
                ></wj-input-time>
            </div>
            <div class="col-md-4 form-group">
                <label for="bsl-requester">Requester</label>
                <wj-combo-box
                    [(ngModel)]="target.requesterHrRef"
                    (ngModelChange)="onRequesterChange($event)"
                    name="bsl-requester"
                    id="bsl-requester"
                    [itemsSource]="requesterOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
            <div class="col-md-4 form-group">
                <label for="bsl-phone">Phone #</label>
                <input type="text" class="form-control" [(ngModel)]="target.phoneNumber" name="bsl-phone" id="bsl-phone" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 form-group">
                <label for="bsl-owners">Ticket owner(s)</label>
                <wj-multi-select
                    id="bsl-owners"
                    name="bsl-owners"
                    [showFilterInput]="true"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [checkedMemberPath]="'$checked'"
                    [placeholder]="'Select one or more users'"
                    [headerFormat]="'{count:n0} selected'"
                    [itemsSource]="ticketOwnerOptions"
                ></wj-multi-select>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 form-group">
                <label for="bsl-notes">Notes</label>
                <textarea class="form-control" [(ngModel)]="target.notes" name="bsl-notes" id="bsl-notes" rows="3"></textarea>
            </div>
        </div>
        @if (target.documentUrls && target.documentUrls.length > 0) {
            <div class="row">
                <div class="col-12 form-group">
                    <label>Documents</label>
                    <div class="row">
                        @for (url of target.documentUrls; let i = $index; track i + '|' + url) {
                            <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                                @if (isPdf(url)) {
                                    <img
                                        class="attachment-pdf-thumb"
                                        style="cursor: pointer"
                                        src="./Resources/pdfImage.png"
                                        (click)="openDocument(url)"
                                        alt=""
                                    />
                                    <div class="small text-muted mt-1">{{ displayDocumentName(i) }}</div>
                                } @else {
                                    <div class="small text-muted" style="cursor: pointer" (click)="openDocument(url)">
                                        {{ displayDocumentName(i) }}
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
        @if (documents.length > 0) {
            <div class="row">
                <div class="col-12 form-group">
                    <label>Documents to upload</label>
                    @for (doc of documents; track doc.name + doc.size + doc.lastModified) {
                        <div class="col-12" style="margin-bottom: 5px">
                            <div
                                class="close-x"
                                style="display: inline-block; margin-right: 8px; cursor: pointer"
                                (click)="removeDocument(doc)"
                            >
                                <fa-icon [icon]="faX"></fa-icon>
                            </div>
                            <span>{{ doc.name }}</span>
                        </div>
                    }
                </div>
            </div>
        }
        <div class="row">
            <div class="col-md-12 form-group">
                <div class="form-check">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        [(ngModel)]="target.isActive"
                        [style.accentColor]="target.isActive ? '#198754' : '#dc3545'"
                        name="bsl-active"
                        id="bsl-active"
                    />
                    <label class="form-check-label" for="bsl-active">Active</label>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div style="margin-right: auto">
            <button type="button" class="btn btn-success" (click)="docInput.click()">Document</button>
            <input
                #docInput
                style="display: none"
                type="file"
                (change)="onDocumentChanged($event)"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
                multiple
            />
        </div>
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span>Saving…</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
